<script>
  import { Doughnut } from 'vue-chartjs'
  import {createChartData, createChartOptions} from './chartTheme'

  export default {
    extends: Doughnut,
    props: {
      chartData: {
        type: Object,
        default: () => ({})
      },
      options: {
        type: Object,
        default: () => ({})
      },      
    },
    mounted () {        
      this.render()
    },
    watch: {
      chartData: function() {
        this.render()
      },
      options: function() {
        this.render()
      },
    }, 
    methods: {
      render() {
        this.renderChart(createChartData(this.chartData), createChartOptions('doughnut', this.options))
      }
    }
  }
</script>
